import { SET_APP_INFO } from './app-info-types'

const initialState = {
  fetching: {},
  summery: {},
  membership: {},
}

export const appInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_APP_INFO:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}
